const l = {
  name: "ShoppingCart",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 33.7" style="enable-background:new 0 0 40 33.7;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22.3,1.4l7.3,7.3H10.4l7.3-7.3L16.3,0L7.6,8.7H0v6h2.2l4,19h27.6l4-19H40v-6h-7.6L23.7,0L22.3,1.4z
			 M26.9,14.7l-0.4,7H21v-7H26.9z M26.5,23.7l-0.4,8H21v-8H26.5z M19,21.7h-5.6l-0.4-7H19V21.7z M13.5,23.7H19v8h-5.1L13.5,23.7z
			 M11.4,21.7H5.7l-1.5-7h6.8L11.4,21.7z M6.1,23.7h5.4l0.4,8H7.8L6.1,23.7z M28.5,23.7h5.4l-1.7,8h-4.1L28.5,23.7z M34.3,21.7h-5.7
			l0.4-7h6.8L34.3,21.7z M38,12.7H2v-2h36V12.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as ShoppingCart
};
